import styled from 'styled-components';

export const Container = styled.div`
  margin: 16px 0;
  display: flex;
  justify-content: space-between;
`;
